'use client';

import cx from 'classnames';
import useHeroScrolledAway from '../hooks/useHeroScrolledAway';
import styles from '../TestDriveCenter.module.css';

const section = 'Test Drive Center - Mobile Bar';

export default function TestDriveCenterMobileBar() {
  const scrolledPastHero = useHeroScrolledAway();

  return (
    <div
      className={cx(styles.mobileBar, {
        [styles.mobileBarVisible]: scrolledPastHero
      })}
    >
      <a
        className="inline-flex h-[42px] flex-1 cursor-pointer items-center justify-center rounded-full border-0 bg-[var(--cvna-blue-bright)] text-[13.5px] font-bold leading-none text-white"
        data-adobe-id="shop-new-cars"
        data-analytics-id={`${section} - Shop New Cars`}
        data-testid="test-drive-center-mobile-search-cars"
        href="/cars"
      >
        Shop New Cars
      </a>
    </div>
  );
}
